import { SolType } from '@sol/components';

export class AsmType {
  public static readonly score = SolType.ofPrimitive<string>(
    'score',
    () => '',
    v => v ?? '',
    s => s,
    SolType.string,
  );
  public static readonly priority = SolType.ofPrimitive<string>(
    'priority',
    () => '',
    v => v ?? '',
    s => s,
    SolType.string,
  );
  public static readonly country = SolType.ofPrimitive<string>(
    'asm.country',
    () => '',
    v => v ?? '',
    s => s,
    SolType.string,
  );
  public static readonly featureKey = SolType.ofPrimitive<string>(
    'featureKey',
    () => '',
    v => v ?? '',
    s => s,
    SolType.string,
  );
}
